

import { Component, Prop, Vue, Watch } from "vue-property-decorator"

// @ts-ignore
import { BModal } from "bootstrap-vue"
import { Getter } from "vuex-class"

@Component({
	components: {
		"b-modal": BModal
	}
})
export default class PendingClosureModal extends Vue {
	@Prop() pendingClosure!: boolean | null
	@Prop() isClosed!: boolean | null
	@Prop() isCase!: boolean

	CLOSING_CASE_DELAY_IN_SECONDS: number = 10;
	isOpen: boolean = !!this.pendingClosure;
	caseSetToClose: boolean = false; // True if user proceeds to close the case

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	// Watch for changes in pendingClosure
	@Watch("pendingClosure")
	onPendingClosureChanged (newVal: boolean | null) : void {
		this.isOpen = this.isClosed ? false : !!newVal
	}

	@Watch("isClosed")
	onCaseIsClosed (isClosed: boolean | null) : void {
		if (this.isOpen && isClosed) {
			this.closeModal() // If case has been closed, close modal
			this.caseSetToClose = false
		}
	}

	private get caseOrRecordName () : string {
		return this.isCase ? this.getCaseName : this.getRecordName
	}

	private closeModal () {
		this.isOpen = false
		if (this.isClosed || this.caseSetToClose) {
			this.caseSetToClose = false
		}
	}

	private closeCase () {
		if (!this.isClosed) {
			this.caseSetToClose = true
			this.$emit("closeCase")
		}
	}
	private cancelCloseCase () {
		if (!this.isClosed) {
			this.closeModal()
			this.caseSetToClose = false
			this.$emit("cancelCloseCase")
		}
	}
}
